export enum FleetType {
  STATIC = "STATIC",
  DYNAMIC = "DYNAMIC",
}
